
const json = x => document.querySelector(x) && JSON.parse(document.querySelector(x).textContent) || undefined
const translations = json('#localization')

export function translate(string) {
	return translations?.[string] || string
}